// extracted by mini-css-extract-plugin
export default {"messageList":"ChatContent_messageList__CXNs6","messageItem":"ChatContent_messageItem__An+lX"};